import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SaveService } from '../shared/services/save.service';

@Component({
  selector: 'app-choice-responsible',
  templateUrl: './choice-responsible.component.html',
  styleUrls: ['./choice-responsible.component.css']
})
export class ChoiceResponsibleComponent implements OnInit {

  constructor(private router: Router,
  private saveService: SaveService) { }

  ngOnInit() {
    this.saveService.setTitle('Mes options');
  }

  addInstitution() {
    this.router.navigate(['institution-create'])
  }

  myInstitution() {
    this.router.navigate(['institution-list'], { queryParams: { 'type': 'favorite' } })
  }

  allInstitution() {
    this.router.navigate(['institution-list'], { queryParams: { 'type': 'all' } })
  }

}



// WEBPACK FOOTER //
// C:/dev/Perso/urmeo/src/app/choice-responsible/choice-responsible.component.ts